module.exports = __webpack_public_path__ + "static/img/shangjia4.6eb72bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/shangjia4.jpg
// module id = 1423
// module chunks = 1